import { base64 } from '../encoding/base64.ts';
import { getAuthGlobalOptions } from '../options.ts';

export interface IBaseAuthStorage {
  isLogged: boolean;
  isPrelogged: boolean;
  strategy: string | null;
  refreshToken: string | null;
  logoutUrls: string[] | null;
  roleId?: string | null;
  officeId?: string | null;
}

interface ICreateAuthStorageOptions<T extends IBaseAuthStorage> {
  storage: Storage;
  initialValues: T;
}

export function createAuthStorage<T extends IBaseAuthStorage>(
  options: ICreateAuthStorageOptions<T>,
) {
  const storageKeyPrefix = `${
    process.env.STORAGE_PREFIX ? `${process.env.STORAGE_PREFIX}.` : ''
  }`;

  return {
    get(): T {
      const storageKey = `${storageKeyPrefix}${
        getAuthGlobalOptions().storageKey
      }`;
      const data = options.storage.getItem(storageKey);

      return {
        ...options.initialValues,
        ...(data && JSON.parse(base64.decode(data))),
      };
    },

    /**
     * Carichiamo i dati iniziali dal `sessionStorage` in caso siano
     * presenti.
     */
    initialState(): T {
      return this.get();
    },

    /**
     * Salviamo lo stato dell'utente corrente sul `sessionStorage`
     */
    saveState(state: T) {
      const storageKey = `${storageKeyPrefix}${
        getAuthGlobalOptions().storageKey
      }`;
      options.storage.setItem(storageKey, base64.encode(JSON.stringify(state)));
    },
  };
}
